// @mui
import {
  enUS,
  idID,
  frFR,
  zhCN,
  viVN,
  arSD,
} from '@mui/material/locale'
// components
import { SettingsValueProps } from './components/settings/type'
// routes
import { PATH_DASHBOARD } from './routes/paths'
export const MAPBOX_API = process.env.MAPBOX_API

export const TERMS_CONDITION_URL =
  process.env.NEXT_PUBLIC_TERMS_CONDITION_URL
export const ASSET_BASE_URL = process.env.NEXT_PUBLIC_ASSET_BASE_URL
export const PROMOTER_LANDING_PAGE =
  process.env.NEXT_PUBLIC_PROMOTER_LANDING_PAGE
// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN =
  PATH_DASHBOARD.creator_center.dashboard // as '/dashboard/app'
export const PROMOTER_HANDBOOK_URL =
  process.env.NEXT_PUBLIC_PROMOTER_HANDBOOK
export const KYC_BANK_ACCOUNT_URL =
  process.env.NEXT_PUBLIC_KYC_FORM_URL

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
}

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
}

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
}

// SETTINGS
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const cookiesExpires = 3

export const cookiesKey = {
  themeMode: 'themeMode',
  themeLayout: 'themeLayout',
  themeStretch: 'themeStretch',
  themeContrast: 'themeContrast',
  themeDirection: 'themeDirection',
  themeColorPresets: 'themeColorPresets',
}

export const defaultSettings: SettingsValueProps = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeContrast: 'default',
  themeLayout: 'horizontal',
  themeColorPresets: 'default',
  themeStretch: false,
}

// MULTI LANGUAGES
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'Bahasa Indonesia',
    value: 'id',
    systemValue: idID,
    icon: '/assets/icons/flags/ic_flag_id.svg',
  },
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/assets/icons/flags/ic_flag_en.svg',
  },
  {
    label: 'French',
    value: 'fr',
    systemValue: frFR,
    icon: '/assets/icons/flags/ic_flag_fr.svg',
  },
  {
    label: 'Vietnamese',
    value: 'vn',
    systemValue: viVN,
    icon: '/assets/icons/flags/ic_flag_vn.svg',
  },
  {
    label: 'Chinese',
    value: 'cn',
    systemValue: zhCN,
    icon: '/assets/icons/flags/ic_flag_cn.svg',
  },
  {
    label: 'Arabic (Sudan)',
    value: 'ar',
    systemValue: arSD,
    icon: '/assets/icons/flags/ic_flag_sa.svg',
  },
]

export const defaultLang = allLangs[0] // Indonesia
